export default "__VITE_ASSET__pIs$GunX__"